import { Icon, TextBadge } from '@packages/ui/shared';
import { useTranslation } from 'react-i18next';

import { ssm5ControlStyles, ssm5TextStyles } from '../ssm5.styles';

const BADGE_ICON_SIZE = 16;

/** How the badge reads for a connection that is open, and for one that is not. */
const BADGE = {
    connected: {
        icon: 'plug',
        iconColor: 'greenOne',
        label: 'ssm5:connection.connected',
        textStyle: ssm5TextStyles.connectedBadgeText,
        variant: 'greenFive',
    },
    disconnected: {
        icon: 'unplugged',
        iconColor: 'blueOne',
        label: 'ssm5:connection.disconnected',
        textStyle: ssm5TextStyles.disconnectedBadgeText,
        variant: 'blue',
    },
} as const;

/** Props for {@link Ssm5ConnectionBadge}. */
export type Ssm5ConnectionBadgeProps = {
    /** Whether the connection is open on its Cloud Connector. */
    isConnected: boolean;
};

/**
 * The rounded chip that tells an open SSM5 connection from one that is gone, shared by the session
 * strip and the recent connections row.
 *
 * @param props - {@link Ssm5ConnectionBadgeProps}
 * @returns the badge
 */
export function Ssm5ConnectionBadge({ isConnected }: Ssm5ConnectionBadgeProps) {
    const { t } = useTranslation();
    const badge = isConnected ? BADGE.connected : BADGE.disconnected;

    return (
        <TextBadge
            icon={<Icon color={badge.iconColor} name={badge.icon} size={BADGE_ICON_SIZE} />}
            style={ssm5ControlStyles.connectionBadge}
            textStyle={badge.textStyle}
            variant={badge.variant}
        >
            {t(badge.label)}
        </TextBadge>
    );
}
